const ITEMS = [
  "Passport Services",
  "Visa Assistance",
  "Urgent Travel Documents",
  "Apostille & Authentication",
  "Business Travel",
  "Translation Services",
  "Washington, DC",
  "20+ Years of Experience",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="px-8 font-display text-sm font-medium uppercase tracking-[0.3em] text-slate-400">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-gold" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    className="overflow-hidden border-y border-white/10 bg-navy-deep py-5"
    data-testid="editorial-marquee"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
